import MapService from '@/services/map-address.service';

export default {
	actions: {
		async getAddress(context, payload) {
			try {
				const resp = await MapService.getAddress(payload).then(resp => resp);
				return resp;
			} catch (error) {
				console.error(error);
			}

		},
	}
};
